// extracted by mini-css-extract-plugin
module.exports = {"icon":"tooltip_icon__zs6Zx"};